"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const WorkflowRunDetail_1 = require("../WorkflowRunDetail");
class WorkflowRuns extends react_1.default.Component {
    render() {
        const showMessage = message => {
            return react_1.default.createElement("p", { className: "text-center lead my-5" }, message);
        };
        if (!this.props.workflow.time) {
            return showMessage('Workflow has no scheduled time');
        }
        if (!this.props.workflow.days) {
            return showMessage('Workflow has no scheduled days');
        }
        const days = this.props.workflow.days.map((d, i) => {
            let day = d.charAt(0).toUpperCase() + d.slice(1);
            if (this.props.workflow.days.length !== 1 && // not just one day
                i === this.props.workflow.days.length - 1 // not all days
            ) {
                day = 'and ' + day;
            }
            return day;
        });
        let daysMessage;
        if (days.length === 7) {
            daysMessage = 'every day';
        }
        else {
            daysMessage = `every ${days.length === 2 ? days.join(' ') : days.join(', ')}`;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            showMessage(`This workflow is scheduled for ${moment_1.default(this.props.workflow.time).format('h:mm a')} ${daysMessage}.`),
            react_1.default.createElement(reusables_1.QueryList, { queryProps: {
                    fetchPolicy: 'cache-and-network',
                    query: graphql_1.workflowRuns,
                }, queryVariables: {
                    orderBy: 'runDateTime',
                    orderDir: 'ASC',
                    workflowId: this.props.workflow.id,
                }, item: WorkflowRunDetail_1.WorkflowRunDetail, itemName: "workflow run", itemsKey: "workflowRuns", itemPadding: false, countKey: "workflowRunsCount", onItemClick: () => {
                    // this.props.onToggle(false);
                } })));
    }
}
exports.WorkflowRuns = WorkflowRuns;
//# sourceMappingURL=WorkflowRuns.js.map